import { useFeatureFlag } from '@shape/feature-flag';
import { Dayjs } from 'lib';
import { useFeatureFlagPayload } from 'posthog-js/react';

const defaultIntervalMap: { [key: string]: string } = {
  '5': '20s',
  '24': '1m',
  '72': '30m',
  '720': '3h',
  '768': '6h',
  '2200': '12h',
  '4400': '24h',
};

export const useInterpolationData = (dateRange: { start: Dayjs; end: Dayjs }) => {
  const isEnabled = useFeatureFlag('test-interpolation');
  const flagPayload = useFeatureFlagPayload('test-interpolation');

  const diffInHours = dateRange.end.diff(dateRange.start, 'hours');

  const intervalMap =
    isEnabled && flagPayload ? (flagPayload as { [key: string]: string }) : defaultIntervalMap;

  const key = Object.keys(intervalMap).find((key) => Number(key) >= diffInHours) ?? '4400';

  return intervalMap[key] ?? '48h';
};
